"use client";

import Reactions from "components/ui/v2/explore/bundle/Reactions";
import type { FormV2Props } from "../form-v2-props";
import type { LiquidPillGroupItem } from "components/ui/v2";

export interface ExploreReactionsModalContentV2Props extends FormV2Props {
  id: string;
  type: "message" | "comment";
  onLoadingChange?: (loading: boolean) => void;
  onTabChange?: (
    tabItems: LiquidPillGroupItem[],
    activeTab: string,
    setActiveTab: (val: string) => void
  ) => void;
  onCountChange?: (count: number) => void;
}

export function ExploreReactionsModalContentV2({
  id,
  type,
  hideHeader = true,
  onLoadingChange,
  onTabChange,
  onCountChange,
}: ExploreReactionsModalContentV2Props) {
  return (
    <Reactions
      id={id}
      type={type}
      embedded
      hideHeader={hideHeader}
      onLoadingChange={onLoadingChange}
      onTabChange={onTabChange}
      onCountChange={onCountChange}
    />
  );
}
